import { render, staticRenderFns } from "./thietLapKySoNoiBo.vue?vue&type=template&id=db97230e&scoped=true&"
import script from "./thietLapKySoNoiBo.vue?vue&type=script&lang=js&"
export * from "./thietLapKySoNoiBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db97230e",
  null
  
)

export default component.exports